var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPromotionIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 39 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1D253C",
    strokeWidth: 3,
    d: "M30.107 17.555H28c.573 7.954 2.393 12.55 3.45 12.867 1.16-.367 3.411-6.51 3.55-17-.324 1.212-.975 2.27-1.857 3.014-.882.745-1.947 1.137-3.036 1.12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1D253C",
    strokeWidth: 3,
    d: "M35.45 14.365C35.175 6.797 32.903 2.355 31.615 2c-1.094.304-2.9 3.575-3.584 9.208h2.184c1.19.005 2.345.316 3.29.886.945.57 1.628 1.367 1.945 2.27Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#1D253C",
    strokeWidth: 3,
    d: "M37 16.423c.017-1.026-.404-2.018-1.175-2.766-.77-.747-1.83-1.19-2.954-1.235H29.16A66.42 66.42 0 0 0 29 16.996c0 1.192.04 2.323.095 3.426h3.783c1.123-.044 2.182-.487 2.952-1.234s1.19-1.74 1.17-2.765Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1D253C",
    strokeWidth: 3,
    d: "m28.195 28.193.405.241c-3.322-9.994-1.234-20.486-.067-24.869l-.34.17a54.04 54.04 0 0 0 0 24.457l.002.001ZM28.195 28.192l-6.019-3.594 6.019 3.594ZM28.19 3.74l-6.483 3.24 6.482-3.24Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1D253C",
    strokeWidth: 3,
    d: "M13.259 9.008H9.954v13.149h3.695c3.01.024 5.955.869 8.52 2.442l6.02 3.594a54.043 54.043 0 0 1 0-24.456l-6.484 3.24a18.903 18.903 0 0 1-8.446 2.031ZM11.565 23.433H6.363v13.324c.002.153.018.305.047.454H6.4c0 .024.014.046.018.068.004.023.011.044.017.067.033.149.08.294.14.435.007.017.017.032.024.048.065.142.143.279.232.407l.025.035c.094.13.2.253.315.365l.022.021c.121.115.253.22.393.31l.016.012a2.856 2.856 0 0 0 1.533.454h.025c.466-.003.925-.12 1.336-.339a2.618 2.618 0 0 0 1.462-2.317V23.432l-.393.001Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1D253C",
    strokeWidth: 3,
    d: "M5 8.422h4c.265 0 .52.074.707.205.188.131.293.31.293.495v12.6c0 .185-.105.364-.293.495a1.25 1.25 0 0 1-.707.205H5c-.796 0-1.559-.221-2.121-.615-.563-.394-.879-.928-.879-1.485v-9.8c0-.557.316-1.091.879-1.485.562-.394 1.325-.615 2.121-.615Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotionIcon);
export default __webpack_public_path__ + "static/media/promotion-icon.86f596621198127dbfe6cb2f1b41f05c.svg";
export { ForwardRef as ReactComponent };